import styled from 'styled-components';

import { lighten, darken } from 'utils/colours';

import { Button as AntdButton } from 'antd';

const Button = styled(AntdButton)`
    &.ant-btn .anticon {
        vertical-align: 0.12em;
    }

    /* type = default */
    &.ant-btn:hover,
    &.ant-btn:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    &.ant-btn:active,
    &.ant-btn.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* type = primary */
    &.ant-btn-primary {
        background-color: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};
        color: #fff;
    }

    &.ant-btn-primary:hover,
    &.ant-btn-primary:focus {
        background-color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        color: #fff;
    }

    &.ant-btn-primary:active,
    &.ant-btn-primary.active {
        background-color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* type = ghost */
    &.ant-btn-ghost:hover,
    &.ant-btn-ghost:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        background-color: transparent;
    }

    &.ant-btn-ghost:active,
    &.ant-btn-ghost.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
        background-color: transparent;
    }

    &.ant-btn-background-ghost.ant-btn-primary {
        color: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};
    }

    &.ant-btn-background-ghost.ant-btn-primary:hover,
    &.ant-btn-background-ghost.ant-btn-primary:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    &.ant-btn-background-ghost.ant-btn-primary:active,
    &.ant-btn-background-ghost.ant-btn-primary.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
    }

    &.ant-btn-background-ghost.ant-btn-link {
        color: ${({ theme }) => theme.colour.primary};
    }

    &.ant-btn-background-ghost.ant-btn-link:hover,
    &.ant-btn-background-ghost.ant-btn-link:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    &.ant-btn-background-ghost.ant-btn-link:active,
    &.ant-btn-background-ghost.ant-btn-link.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* type = dashed */
    &.ant-btn-dashed:hover,
    &.ant-btn-dashed:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    &.ant-btn-dashed:active,
    &.ant-btn-dashed.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
        border-color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* type = link */
    &.ant-btn-link {
        color: ${({ theme }) => theme.colour.primary};
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    &.ant-btn-link:hover,
    &.ant-btn-link:focus {
        color: ${({ theme }) => lighten(theme.colour.primary)};
        border-color: transparent;
    }

    &.ant-btn-link:active,
    &.ant-btn-link.active {
        color: ${({ theme }) => darken(theme.colour.primary)};
    }

    /* type = danger - re-force default danger styles */
    &&.ant-btn-dangerous {
        color: #ff4d4f;
        background-color: #fff;
        border-color: #ff4d4f;
    }
    &&.ant-btn-dangerous:hover,
    &&.ant-btn-dangerous:focus {
        color: #ff7875;
        background-color: #fff;
        border-color: #ff7875;
    }
    &&.ant-btn-dangerous.ant-btn-primary {
        color: #fff;
        background-color: #ff4d4f;
        border-color: #ff4d4f;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
        box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    }
    &&.ant-btn-dangerous.ant-btn-primary:hover,
    &&.ant-btn-dangerous.ant-btn-primary:focus {
        color: #fff;
        background-color: #ff7875;
        border-color: #ff7875;
    }
    &&.ant-btn-dangerous.ant-btn-link {
        color: #ff4d4f;
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    &&.ant-btn-background-ghost.ant-btn-dangerous {
        color: #ff4d4f;
        background-color: transparent;
        border-color: #ff4d4f;
        text-shadow: none;
    }
    &&.ant-btn-background-ghost.ant-btn-dangerous:hover,
    &&.ant-btn-background-ghost.ant-btn-dangerous:focus {
        color: #ff7875;
        background-color: transparent;
        border-color: #ff7875;
    }
    &&.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {
        color: #ff4d4f;
        background-color: transparent;
        border-color: transparent;
        text-shadow: none;
    }
    &&.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover,
    &&.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus {
        color: #ff7875;
        background-color: transparent;
        border-color: transparent;
    }

    /* Disabled style override for all types */
    &.ant-btn-disabled,
    &.ant-btn.disabled,
    &.ant-btn[disabled],
    &.ant-btn-dangerous-disabled,
    &.ant-btn-dangerous.disabled,
    &.ant-btn-dangerous[disabled],
    &.ant-btn-primary-disabled,
    &.ant-btn-primary.disabled,
    &.ant-btn-primary[disabled],
    &.ant-btn-dangerous.ant-btn-primary-disabled,
    &.ant-btn-dangerous.ant-btn-primary.disabled,
    &.ant-btn-dangerous.ant-btn-primary[disabled],
    &.ant-btn-background-ghost.ant-btn-dangerous-disabled,
    &.ant-btn-background-ghost.ant-btn-dangerous.disabled,
    &.ant-btn-background-ghost.ant-btn-dangerous[disabled] {
        &,
        &:hover,
        &:focus,
        &:active,
        &.active {
            color: rgba(0, 0, 0, 0.25);
            background-color: #f5f5f5;
            border-color: #d9d9d9;
            text-shadow: none;
            box-shadow: none;
        }
    }

    &.ant-btn-link-disabled,
    &.ant-btn-link.disabled,
    &.ant-btn-link[disabled],
    &.ant-btn-dangerous.ant-btn-link-disabled,
    &.ant-btn-dangerous.ant-btn-link.disabled,
    &.ant-btn-dangerous.ant-btn-link[disabled],
    &.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link-disabled,
    &.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link.disabled,
    &.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] {
        &,
        &:hover,
        &:focus,
        &:active,
        &.active {
            color: rgba(0, 0, 0, 0.25);
            background-color: transparent;
            border-color: transparent;
            text-shadow: none;
            box-shadow: none;
        }
    }
`;

export default Button;
